import type { CookieEntity } from '../entities/CookieConfig';
import { BrowserCookies } from './BrowserCookies';
import { BrowserDB } from './BrowserDB';

const COOKIES_CONFIG_KEY = 'cookies_config';

export class CookiesRepository {
  static getConfig() {
    const storedConfig = BrowserDB.get<Partial<CookieEntity>>(COOKIES_CONFIG_KEY);
    if (!storedConfig) {
      this.saveConfig(defaultCookieState);
      return defaultCookieState;
    }
    const sanitizedConfig: CookieEntity = this.sanitizeConfig(storedConfig);
    if (JSON.stringify(sanitizedConfig) !== JSON.stringify(storedConfig)) {
      this.saveConfig(sanitizedConfig);
    }

    return sanitizedConfig;
  }

  static saveConfig(config: Partial<CookieEntity>): void {
    const sanitizedConfig = this.sanitizeConfig(config);
    BrowserDB.set(COOKIES_CONFIG_KEY, sanitizedConfig);
  }

  private static sanitizeConfig(config: Partial<CookieEntity>): CookieEntity {
    const sanitizedConfig: CookieEntity = { ...defaultCookieState };

    (Object.keys(defaultCookieState) as (keyof CookieEntity)[]).forEach((key) => {
      if (config[key] !== undefined) {
        //@ts-ignore
        sanitizedConfig[key] = config[key] as AppConfig[keyof AppConfig];
      }
    });

    return sanitizedConfig;
  }

  setCookie(name: string, value: string, days?: number) {
    return BrowserCookies.set(name, value, days);
  }
}
